
import { defineComponent, ref, reactive, toRefs, onMounted, warn, watch, nextTick, computed } from 'vue'
import { ArrowUpOutlined, ArrowDownOutlined, DownOutlined, UpOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import f10Api from '@/api/f10Api'
import globalsets from '../utils/globalsets'
import ws from '../websocket/index'
import f10ApiHk from '@/api/f10ApiHk'
import { eventBus } from '@/utils/eventBus'
import { MESSAGEID_DEF } from '@/websocket/quotationWebsocket'
export default defineComponent({
  components: { DownOutlined, UpOutlined },
  props: {
    token: {
      type: String,
      default: function () {
        return ''
      }
    },
    theme: {
      type: String,
      default: function () {
        return ''
      }
    },
    type: {
      type: String,
      default: function () {
        return 'hk'
      }
    }
  },
  setup(props: any, context) {
    const route = useRoute()
    const pageData: any = reactive({
      anchorbg: require('@/assets/anchorbg.png'),
      lis: [],
      nav: [],
      currentli: '',
      activeIndex: '',
      target: () => document.querySelector('.wrapper'),
      isOpen: true,
      currentshares: {
        LastPrice: 0,
        RiseandFall: 0,
        PreClosePrice: 0,
        increase: 0,
        InstrumentID: '',
        name: '',
        key: new Date().getTime() + ''
      },
      websock: null,

    })
    const isDelayHK = ref(false)
    const dataTool = ref(null) as any

    // 判断是否为美股市场
    const isUSMarket = computed(() => {
      const marketLower = String(route.query.market || '').toLowerCase()
      return marketLower === 'nyse' || marketLower === 'amex' || marketLower === 'nasdaq' || marketLower === 'na'
    })

    // 判断是否为港股市场
    const isHKMarket = computed(() => {
      return route.query.market == 'hkse' || route.query.exchange == 'HKEX'
    })

    // 格式化价格显示
    const getFormattedPrice = (price: number) => {
      if (isUSMarket.value) {
        return globalsets.getUSPrice(price)
      } else if (isHKMarket.value) {
        return globalsets.getHKPrice(price)
      }
      return globalsets.getNumber3(price) // 默认格式
    }

    // 格式化涨跌显示
    const getFormattedChange = (change: number) => {
      if (isUSMarket.value) {
        // 美股需要传递价格参数来确定精度
        const price = pageData.currentshares?.LastPrice || 0
        return globalsets.getUSChange(change, price)
      } else if (isHKMarket.value) {
        return globalsets.getHKChange(change)
      }
      return globalsets.getNumber3(change) // 默认格式
    }

    // 格式化涨跌幅显示
    const getFormattedChangePercent = (changePercent: number) => {
      if (isUSMarket.value) {
        return globalsets.getUSChangePercent(changePercent)
      } else if (isHKMarket.value) {
        return globalsets.getHKChangePercent(changePercent)
      }
      return (changePercent > 0 ? '+' : '') + globalsets.getPencent(changePercent) // 默认格式
    }
    pageData.lis = [
      {
        key: 'zxdt',
        name: '最新动态'
      },
      {
        key: 'gszl',
        name: '公司资料'
      },
      {
        key: 'gsxd',
        name: '公司行动'
      },
      {
        key: 'cwgk',
        name: '财务概况'
      },
      {
        key: 'ggjs',
        name: '高管介绍'
      },
      {
        key: 'hydb',
        name: '行业对比'
      },
      {
        key: 'zxgg',
        name: '资讯公告'
      },
      {
        key: 'gdch',
        name: '股东持股'
      },
      {
        key: 'jyfx',
        name: '经营分析'
      },
      {
        key: 'ssetf',
        name: '所属ETF'
      },
      {
        key: 'gzfx',
        name: '估值分析'
      },

    ]
    function selecthash(e: any, link: any) {
      e.preventDefault()
    }
    const getBriefIndexInfos = () => {

      const token = props.token || 'e2bfcc9278acca667bdc6abd7a75598d'
      const ts = parseInt((new Date().getTime() / 1000) as any)
      const secret = 'U7KK2GV5GH68'
      const sign = window.Md5.hashStr(`${token}${ts}${secret}`)

      // 传参
      const data = {
        data: {
          token,
          _t: ts,
          _sign: sign
        },
        headers: {
          agent: 'pc_client',
          version: route.query.version,
        }
      }

      f10ApiHk.getBriefIndexInfo(data).then((res: any) => {
        // isDelayHK.value = calcIsDelayHK(res?.data)
        // 根据当前的 路径上的 HKDELAY == 0 是延时   


      }).catch(() => {
        // isDelayHK.value = false
      })
    }

    function calcIsDelayHK(user: any) {
      const rights2 = Array.isArray(user?.quote_right2) ? user.quote_right2 : []
      const delay2 = rights2.some((it: any) => {
        const exch = String(it?.exchange || '').toUpperCase()
        const mkt = String(it?.market || '')
        return exch === 'HKEX' && mkt === '' && String(it?.right) === '0'
      })
      return delay2
    }
    onMounted(() => {
      // if (route.query.HKDELAY == '0' || route.query.USDELAY == '0') {

      //   isDelayHK.value = true
      // } else {
      //   console.log('打印监听数据isDelayHK', route.query.HKDELAY, route.query.USDELAY)
      //   isDelayHK.value = false
      // }
      // 1. 判断是否为港股市场
      isDelayHK.value = (route.query.market == 'hkse' || route.query.exchange == 'HKEX')
        ? route.query.HKDELAY == '1'
        : route.query.USDELAY == '1';


      const marketLower = String(route.query.market || '').toLowerCase()


      const marketRaw = String(route.query.market || '')
      const exch = isDelayHK.value ? 'DELAY_' + marketRaw : marketRaw

      const now = new Date()
      const hours = now.getHours()
      if (hours >= 16) {
        if (marketLower === 'nyse' || marketLower === 'amex' || marketLower === 'nasdaq' || marketLower === 'na') {
          dataTool.value = MESSAGEID_DEF.MSGID_USSTOCK_HQ_SNAP_REG

        }
      }
      ws.websocket.safeSubscribeDYNA(route.query.code, exch, dataTool.value)
      console.log('dataTool.value', dataTool.value)
      getBriefIndexInfos()
    })


    // route.query.code, route.query.market

    console.log('打印监听数据messageId', route.query.market)

    // ws.websocket.safeSubscribeDYNA(route.query.code, isDelayHK.value ? 'DELAY_' + route.query.market : route.query.market, dataTool.value)
    ws.websocket.on('onMessage', msg => {
      const _data = msg.QuoteData

      // 检查是否是当前股票的数据
      const isCurrentStock = msg.Inst == route.query.code

      if (!isCurrentStock) {
        console.log('打印监听数据isCurrentStock', msg, _data)

        // 如果不是当前股票，通过eventBus通知其他组件
        eventBus.emit('otherStockMessage', msg)
        return
      }

      console.log('打印监听数据isCurrentStock111', _data)
      if (_data && _data.StatisticsData && (_data.StatisticsData || []).length > 0) {
        pageData.currentshares.PreClosePrice = _data.StatisticsData[0].PreClosePrice
        pageData.currentshares.InstrumentID = _data.StatisticsData[0].InstrumentID
      }

      if (_data && _data.StaticData && (_data.StaticData || []).length > 0) {

        pageData.currentshares.name = _data.StaticData[0].InstrumentName
        context.emit('currentshares', pageData.currentshares)

      }

      if (_data && _data.DynaData && (_data.DynaData || []).length > 0) {
        pageData.currentshares.LastPrice = _data.DynaData[0].LastPrice || null
      }

      if (_data && (_data.InstStatusData || [])[0]) {
        pageData.currentshares.InstStatus = ((msg.QuoteData.InstStatusData || [])[0] || {}).StatusType
      }

      // 停牌
      if (pageData.currentshares.InstStatus === 6) {
        pageData.currentshares.RiseandFall = null
        pageData.currentshares.increase = null
        pageData.currentshares.LastPrice = null
      } else {
        pageData.currentshares.RiseandFall = pageData.currentshares.LastPrice - pageData.currentshares.PreClosePrice
        pageData.currentshares.increase =
          ((pageData.currentshares.LastPrice - pageData.currentshares.PreClosePrice) / pageData.currentshares.PreClosePrice) * 100
      }
    })
    // 点击 li
    function changenav(item: any) {
      pageData.currentli = item.key
      const softNameAbbr = route.query.softNameAbbr as string
      const versionStr: any = route.query.version || ''
      const version = parseFloat(versionStr.split('.').join('') || '0')
      context.emit('clickNav', item.key)
      /**
       * key 值尽量不修改，如有修改，需要通知原生修改跳转连接
       * H5项目 需求 ID ID1109794
       */
      switch (item.key) {
        case 'zxdt':
          pageData.nav = [
            {
              key: 'gsgy',
              title: '公司概要',
              seemore: false
            },
            {
              key: 'zxzb',
              title: '最新指标',
              seemore: 'seemore',
              seemoredesc: '查看更多',
              target: 'cwgk,zyzb'
            },

            {
              key: 'gszx',
              title: '公司资讯',
              seemore: 'seemore',
              seemoredesc: '查看更多',
              target: 'zxgg,gszx'
            },
            {
              key: 'gsgg',
              title: '公司公告',
              seemore: 'seemore',
              seemoredesc: '查看更多',
              target: 'zxgg,gsgg'
            },
            {
              key: 'cwzb',
              title: '财务指标',
              seemore: 'seemore',
              seemoredesc: '查看更多',
              target: 'hydb,zxzb'
            },

            props.type != 'hk' &&
            {
              key: 'jgcc',
              title: '机构持仓',
              seemore: false
            },
          ].filter(Boolean)
          // getlatest()
          // getBriefFinances()
          break
        case 'gszl':
          pageData.nav = [
            {
              key: 'xxqk',
              title: '详细情况'
            },
            {
              key: 'zjzl',
              title: '证券资料'
            }
          ]
          // getorginfo()
          break
        case 'gsxd':




          pageData.nav = props.type === 'hk' ? [
            {
              "key": "fhtj",
              "title": "分红统计"
            },
            {
              "key": "fhpx",
              "title": "分红派息"
            },
            {
              "key": "fchb",
              "title": "分拆合并"
            },
            {
              "key": "gphg",
              "title": "股票回购"
            }
          ] : [
            {
              "key": "fh",
              "title": "分红"
            },
            {
              "key": "cg",
              "title": "拆股"
            },

          ]
          // getholderresearch()
          break

        case 'cwgk':
          pageData.nav = props.type === 'hk' ? [
            {
              "key": "zyzb",
              "title": "主要指标"
            },
            {
              "key": "zcfzb",
              "title": "资产负债表"
            },
            {
              "key": "lrb",
              "title": "利润表"
            },
            {
              "key": "xjllb",
              "title": "现金流量表"
            },
            {
              "key": "gxxg",
              "title": "股息相关"
            }
          ] : [
            {
              "key": "zyzb",
              "title": "主要指标"
            },
            {
              "key": "zcfzb",
              "title": "资产负债表"
            },
            {
              "key": "lrb",
              "title": "利润表"
            },
            {
              "key": "xjllb",
              "title": "现金流量表"
            },
            {
              "key": "gxxg",
              "title": "股息相关"
            }
          ]
          // getbusinessanalysis()
          break
        case 'ggjs':
          pageData.nav = [
            {
              "key": "dshcy",
              "title": "董事会成员"
            },
            {
              "key": "glccy",
              "title": "管理层成员"
            }
          ]
          // getcapitalstructure()

          break
        case 'hydb':
          pageData.nav = [
            {
              key: 'cwzbnewZui',
              title: '财务指标'
            },
          ]
          // getprofitforecast()
          break
        case 'zxgg':
          pageData.nav = [
            {
              "key": "gszx",
              "title": "公司资讯"
            },
            {
              "key": "gsgg",
              "title": "公司公告"
            }
          ]
          // getleadershare()
          break
        case 'gdch':
          pageData.nav = [
            {
              "key": "zygd",
              "title": "主要股东"
            },
            {
              "key": "gbbd",
              "title": "股本变动"
            }
          ]
          // getFinanceF10()
          break
        case 'jyfx':
          pageData.nav = [
            {
              key: 'zyjs',
              title: '主营介绍'
            },
            {
              key: 'zygcfx',
              title: '主营构成分析'
            },

          ]
          // getMarginF10DividendFinance()
          break
        case 'ssetf':
          pageData.nav = [
            {
              key: 'ssetf',
              title: '所属ETF'
            },

          ]
          // getBigevent()
          break
        case 'gzfx':
          pageData.nav = [
            {
              key: 'pesylttm',
              title: 'PE-市盈率TTM'
            },
            {
              key: 'pbsyllf',
              title: 'PB-市净率LF'
            },
            {
              key: 'pssylttm',
              title: 'PS-市销率TTM'
            }
          ]
          // getInfoF10IndustryComparison()
          break

      }
      pageData.key = new Date().getTime() + ''
      context.emit('setnav', pageData.nav)
    }
    function changehash(e: any) {
      pageData.activeIndex = e.split('#')[1]
    }
    function getlatest() {
      const data: any = {}
      // 0：日期（默认），1：股票ID，2：评价，3：变动（1为首次,2为调高,3为调低,4为维持），4：目标价，5：机构，6：作者
      // 0:desc（默认）,1:asc
      data.data = {
        market: route.query.market || 'HK',
        symbol: route.query.code || '00700'
      }
      data.headers = {
        token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
      }

      f10ApiHk.getBriefDetail(data).then((res: any) => {

        context.emit('getPageData', res.data)
      })
    }
    function getBriefFinances() {
      const data: any = {}
      // 0：日期（默认），1：股票ID，2：评价，3：变动（1为首次,2为调高,3为调低,4为维持），4：目标价，5：机构，6：作者
      // 0:desc（默认）,1:asc
      data.data = {
        market: route.query.market || 'HK',
        symbol: route.query.code || '00700'
      }
      data.headers = {
        token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
      }
      f10ApiHk.getBriefFinance(data).then((res: any) => {

        context.emit('getPageData', res.data)
      })
    }

    // 详细情况
    function getorginfo() {
      const data: any = {}
      // 0：日期（默认），1：股票ID，2：评价，3：变动（1为首次,2为调高,3为调低,4为维持），4：目标价，5：机构，6：作者
      // 0:desc（默认）,1:asc
      data.data = {
        ExchangeID: route.query.market,
        InstrumentID: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getorginfo(data).then((res: any) => {
        console.log('f10Api')
        context.emit('getPageData', res.Data)
      })
    }
    // 股东研究
    function getholderresearch() {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getholderresearch(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 经营分析
    function getbusinessanalysis() {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getbusinessanalysis(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 股本结构
    function getcapitalstructure() {
      const data: any = {}
      data.data = {
        market: route.query.market || 'HK',
        symbol: route.query.symbol || '00700'
      }
      data.headers = {
        token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
      }
      f10ApiHk.getBriefManagement(data).then((res: any) => {
        context.emit('getPageData', res.data)
      })
    }


    // 高管列表
    function getleadershare() {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getleadershare(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 盈利预测
    function getprofitforecast() {
      const data: any = {}
      data.data = {
        Exch: ((route.query.market as string) || '').toLowerCase(),
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getprofitforecast(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    function getnewsnotice() {
      const data: any = {}
      // 0：日期（默认），1：股票ID，2：评价，3：变动（1为首次,2为调高,3为调低,4为维持），4：目标价，5：机构，6：作者
      // 0:desc（默认）,1:asc
      data.data = {
        Exch: ((route.query.market as string) || '').toLowerCase(),
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getnewsnotice(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 行业对比
    function getInfoF10IndustryComparison() {
      const data: any = {}
      // 0：日期（默认），1：股票ID，2：评价，3：变动（1为首次,2为调高,3为调低,4为维持），4：目标价，5：机构，6：作者
      // 0:desc（默认）,1:asc
      data.data = {
        Exch: ((route.query.market as string) || '').toLowerCase(),
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getInfoF10IndustryComparison(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 财务分析
    function getFinanceF10() {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code,
        DataType: 31,
        StaticsType: 1
      }
      data.headers = {
        token: props.token
      }
      f10Api.getFinanceF10(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 分红融资
    function getMarginF10DividendFinance() {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getMarginF10DividendFinance(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 公司大事
    function getBigevent() {
      const data: any = {}
      data.data = {
        Exch: ((route.query.market as string) || '').toLowerCase(),
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getBigevent(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 此处根据query 判断，跳到对应的页面 route.query.topnav
    const topnav = route.query.topnav
    const index = topnav ? pageData.lis.findIndex((item: any) => item.key === topnav) : '0'
    changenav(pageData.lis[index])
    function setcurrentli(data: any) {
      changenav(data)
      nextTick(() => {
        setTimeout(() => {
          const index = pageData.nav.findIndex((item: any) => item.key === data.itemkey)
          const dom: any = document.querySelectorAll('.ant-anchor-link-title')
          dom[index].click()
        }, 300)
      })
    }
    watch(
      () => pageData.isOpen,
      () => {
        context.emit('isopen', pageData.isOpen)
      }
    )
    return {
      ...toRefs(pageData),
      selecthash,
      changenav,
      changehash,
      setcurrentli,
      getNumber: globalsets.getNumber,
      getPencent: globalsets.getPencent,
      getNumber2: globalsets.getNumber2,
      getNumber3: globalsets.getNumber3,
      getFormattedPrice,
      getFormattedChange,
      getFormattedChangePercent,
      isDelayHK,
      dataTool,
      // 确保模板中使用的属性都被导出
      // currentshares: pageData.currentshares,
      // isOpen: pageData.isOpen,
      // lis: pageData.lis,
      // currentli: pageData.currentli,
      // nav: pageData.nav,
      // key: pageData.key,
      // target: pageData.target
    }
  }
})
